import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-main-loader"
}

import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { routeHistory } from '@/router';
import { useTelegramWebApp } from '@/services/telegram-web-app';
import useShoppingCartStore from '@/store/shopping-cart';
import AppLoader from '@/components/AppLoader.vue';
import useAppConfigStore from '@/store/app-config';
import useProfileStore from '@/store/profile';
import { useI18n } from 'vue-i18n';
import ApiRepository from '@/repositories/api';
import { Locale } from '@/types/app';
import AppTopAlert from '@/components/AppTopAlert.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const telegramWebApp = useTelegramWebApp();
const appConfigStore = useAppConfigStore();
const shoppingCartStore = useShoppingCartStore();
const profileStore = useProfileStore();
const i18n = useI18n({ useScope: 'global' });

const isInited = ref(false);

const updateTheme = () => {
  const items = document.querySelectorAll('.theme-light, .theme-dark');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < items.length; i++) {
    items[i].classList.remove('theme-light', 'theme-dark');
    items[i].classList.add(`theme-${telegramWebApp.colorScheme}`);
  }
  const surfaceColor = getComputedStyle(document.documentElement).getPropertyValue('--color-surface');
  telegramWebApp.headerColor = surfaceColor;
  telegramWebApp.backgroundColor = surfaceColor;
};

const init = async () => {
  document.body.classList.add(`theme-${telegramWebApp.colorScheme}`);
  document.documentElement.classList.add(`theme-${telegramWebApp.colorScheme}`);
  updateTheme();
  i18n.locale.value = i18n.availableLocales.indexOf(telegramWebApp.languageCode || '') !== -1
    ? telegramWebApp.languageCode as string
    : i18n.fallbackLocale.value as string;
  ApiRepository.locale = i18n.locale.value as Locale;
  await ApiRepository.twaAuth(telegramWebApp.getInitData());
  await appConfigStore.loadConfig();
  profileStore.loadProfile();
  telegramWebApp.expand();
  telegramWebApp.onThemeChanged(updateTheme);
  isInited.value = true;
  await shoppingCartStore.load();
};

onMounted(() => init());

watch(route, (to, from) => {
  if (routeHistory.state.back) {
    telegramWebApp.showBackBtn();
  } else {
    telegramWebApp.hideBackBtn();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppTopAlert),
    (!isInited.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AppLoader)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ], 64))
}
}

})